/* ESM wrapper for CommonJS type tokens to provide a stable default export */
const cjs = require('./type');
const typeTokens = (cjs && cjs.default && cjs.default !== cjs) ? cjs.default : cjs;
export default typeTokens;

